import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53a7ce42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = {
  class: "pl10 letter-spacing mt10",
  style: {"display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loading-dot",
  style: {"color":"var(--black-light)"}
}, "•••", -1))

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.mode)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.className, "flash-app row txt-center"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          style: _normalizeStyle(_ctx.sizes),
          class: "loader"
        }, null, 4),
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.lang === "en" ? "Processing" : "កំពុងដំណើរការ") + " ", 1),
          _hoisted_3
        ])
      ])
    ], 2)
  ], 2))
}